var React = require('react');

var { library } = require('@fortawesome/fontawesome-svg-core');
var { faTimes, faAngleDoubleUp } = require('@fortawesome/free-solid-svg-icons');

library.add(faTimes)
library.add(faAngleDoubleUp)

require('./WizeBot.scss');

class WizeBotModule extends React.Component {
	constructor(props) {
		super(props);

		this.cookieKey = "OptanonConsent";

		this.state = {
			cookieBannerVisible: false
		};

		this.state = {
			isOpen: false,
		};
	}

	componentDidMount = () => {
		this.setState({
			cookieBannerVisible: this.getCookie(this.cookieKey) === null
		});
	}

	toggleChat = () => {
		this.setState({
			isOpen: !this.state.isOpen,
		});
	};

	getCookie = (name) => {
        var nameEquals = name + "=";
        var cookies = document.cookie.split(';');
        for(var i=0; i < cookies.length; i++) {
            var cookie = cookies[i];
            while (cookie.charAt(0) === ' ') cookie = cookie.substring(1, cookie.length);
            if (cookie.indexOf(nameEquals) === 0) return cookie.substring(nameEquals.length, cookie.length);
        }
        return null;
	};

	render(){
		return (
			<div className={"WizeBot__container" + (this.state.isOpen ? " open" : "")}>
				<button className={"WizeBot__button"+ (this.state.cookieBannerVisible ? " cookieBannerVisible" : "")} onClick={this.toggleChat}>{ this.state.isOpen ? 'Hide' : 'Help ?' }</button>
				<iframe className="WizeBot" title="chat" src="https://s3.us-east-2.amazonaws.com/public-artifacts.bots-platform.com/webchats/tottenham/wc.html" />
			</div>
		)
	}
}

module.exports = WizeBotModule;



// WEBPACK FOOTER //
// ./src/components/WizeBot/WizeBotModule.js